var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoPaginationBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "18px",
    height: "14.94px",
    viewBox: "0 0 18 14.94",
    style: {
      enableBackground: "new 0 0 18 14.94"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:currentColor;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_161",
    transform: "translate(-1266 -2279.627)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_21",
    className: "st0",
    d: "M1275.21,2292.83l-5.73-5.73l5.73-5.73l-1.74-1.74l-7.47,7.47l7.47,7.47L1275.21,2292.83z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_22",
    className: "st0",
    d: "M1284,2292.83l-5.73-5.73l5.73-5.73l-1.74-1.74l-7.47,7.47l7.47,7.47L1284,2292.83z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPaginationBack);
export default __webpack_public_path__ + "static/media/ico_pagination_back.320bee2ed3028dccf9f84876dd3e8d8a.svg";
export { ForwardRef as ReactComponent };